import React from 'react';
import { Button } from '@pushpay/button';
import { LoadingOvalIcon, TickIcon } from '@pushpay/iconography';
import { clsx } from '@pushpay/styles';
import { useMenuContext } from './menu-context';
import { useStyles } from './styles';
export const MenuItem = ({
  children,
  className: classNameProp,
  classes: classesProp,
  component,
  disableSelection = false,
  itemValue: value,
  label,
  leftElement,
  onClick,
  rightElement,
  role = 'menuitemradio',
  selectionStyle: selectionStyleOverride,
  loading = false,
  ...rest
}) => {
  const Component = component !== null && component !== void 0 ? component : Button;
  const {
    displayStyle,
    getItemProps,
    selectionStyle: defaultSelectionStyle
  } = useMenuContext();
  const selectionStyle = selectionStyleOverride !== null && selectionStyleOverride !== void 0 ? selectionStyleOverride : defaultSelectionStyle;
  const {
    isSelected,
    onSelected,
    props
  } = getItemProps(value);
  const classes = useStyles(classesProp, {
    displayStyle,
    disableSelection,
    hasLeftElement: !!leftElement,
    hasRightElement: !!rightElement,
    isSelected,
    selectionStyle
  });
  const rootClasses = clsx(classNameProp, classes.menuItem);
  const shouldShowTick = isSelected && selectionStyle === 'tick';
  const handleClick = React.useMemo(() => {
    if (disableSelection) return undefined;
    return e => {
      onSelected();
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
  }, [disableSelection, onClick, onSelected]);
  const handleEnterPress = React.useCallback(event => {
    /**
     * This is necessary to circumvent places where Enter keypresses might be intercepted,
     * such as Dropdown
     */
    if (event.key === 'Enter') {
      handleClick === null || handleClick === void 0 ? void 0 : handleClick(event);
    }
  }, [handleClick]);

  const getIcon = () => {
    if (loading) {
      return /*#__PURE__*/React.createElement(LoadingOvalIcon, {
        className: classes.menuItemSelectedIcon,
        "aria-label": "loading"
      });
    }

    return shouldShowTick && /*#__PURE__*/React.createElement(TickIcon, {
      className: classes.menuItemSelectedIcon,
      displaySize: "large",
      "aria-label": "selected menu item"
    });
  };

  return /*#__PURE__*/React.createElement(Component, Object.assign({}, rest, props, {
    "aria-checked": isSelected,
    "aria-disabled": disableSelection,
    disabled: disableSelection,
    className: rootClasses,
    onClick: handleClick,
    role: role,
    type: "button",
    onKeyDown: handleEnterPress
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.menuItemMainContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.menuItemLeftContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.menuItemLeftElement
  }, leftElement), /*#__PURE__*/React.createElement("div", {
    className: classes.menuItemLabel
  }, label)), /*#__PURE__*/React.createElement("div", {
    className: classes.menuItemRightContent
  }, rightElement, getIcon())), children && /*#__PURE__*/React.createElement("div", {
    className: classes.menuItemExtraContent
  }, children));
};